import type { Place } from '@barboxx/models/types';

import { api } from '../api';

const rootPath = 'places';

export function getPlaces(query: Place.SearchQuery) {
    return api.get<Place.SearchResponse>(`${rootPath}`, query);
}

export function getPlace(id: string) {
    return api.get<Place.DetailsResponse>(`${rootPath}/${id}`);
}

export function updatePlace(id: string, data: Place.UpdateRequest) {
    return api.put<Place.UpdateResponse>(`${rootPath}/${id}`, data);
}

export function createPlace(data: Place.CreateRequest) {
    return api.post<Place.CreateRequest, Place>(`${rootPath}/`, data);
}
export function deletePlace(id: string) {
    return api.delete<number>(`${rootPath}/${id}`);
}

export function followPlace(data: Place.FollowRequest) {
    return api.post<Place.FollowRequest, Place.FollowResponse>(
        `${rootPath}/follow`,
        data
    );
}

export function unFollowPlace(data: Place.UnFollowRequest) {
    return api.delete<Place.UnFollowRequest, Place.FollowResponse>(
        `${rootPath}/follow`,
        data
    );
}
